import React, { useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';
import { useLazyGetActivityDistributionQuery } from '../../../../services/Api';

function ActivityChart() {
    const [trigger, { data: Data, isLoading, error }] = useLazyGetActivityDistributionQuery();

    useEffect(() => {
        trigger();
    }, [trigger]);

    const chartData = Data?.data?.data?.map((item) => ({
        x: item.x,
        y: item.y,
    })) || [];

    // Map X values to custom labels
    const labelMapping = {
        1: "Urban",
        2: "Outdoor",
    };

    return (
        <div className="w-full max-w-md">
            <div className="h-[320px] relative">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={chartData} margin={{ top: 10, right: 0, left: -30, bottom: 20 }}>
                        <CartesianGrid
                            strokeDasharray="3 3"
                            horizontal={true}
                            vertical={true}
                            stroke="#333333"
                        />
                        <XAxis
                            dataKey="x"
                            axisLine={false}
                            tickLine={false}
                            tick={false}
                        />
                        <YAxis
                            axisLine={false}
                            tickLine={false}
                            tick={{ fontSize: 12 }}
                            domain={[0, 100]}
                            ticks={[0, 20, 40, 60, 80, 100]}
                        />
                        <Bar
                            dataKey="y"
                            fill="#FEEE91"
                            radius={[4, 4, 0, 0]}
                        />
                        <Tooltip
                            contentStyle={{
                                backgroundColor: '#F1F1F1',
                                color: '#333',
                                borderRadius: '8px',
                                padding: '8px',
                                fontSize: '14px',
                            }}
                            labelStyle={{
                                fontWeight: 'bold',
                                fontSize: '14px',
                            }}
                            formatter={(value, name) => [`${value}`, `${name}`]}
                        />
                    </BarChart>
                </ResponsiveContainer>
                {/* Custom X-axis labels with arrow */}
                <div className="absolute bottom-0 left-0 right-0 flex justify-between items-center px-8 py-2 mb-4">
                    <span className="font-quicksand text-sm font-medium ml-6">{labelMapping[1]}</span>
                    <div className="flex-1 mx-4 flex items-center justify-center relative">
                        <div className="h-[1px] bg-black flex-1 relative">
                            <div className="absolute top-1/2 -translate-y-1/2 w-2 h-2 bg-black rounded-xl" style={{ left: '25%' }}></div>
                            <div className="absolute top-1/2 -translate-y-1/2 w-2 h-2 bg-black rounded-xl" style={{ left: '50%' }}></div>
                            <div className="absolute top-1/2 -translate-y-1/2 w-2 h-2 bg-black rounded-xl" style={{ left: '75%' }}></div>
                        </div>
                        {/* Arrow head */}
                        <div className="absolute right-0 top-1/2 -translate-y-1/2 -translate-x-1/2 flex flex-col">
                            <div className="w-2 h-[1px] bg-black rotate-45 origin-right"></div>
                            <div className="w-2 h-[1px] bg-black -rotate-45 origin-right"></div>
                        </div>
                    </div>
                    <span className="font-quicksand text-sm font-medium">{labelMapping[2]}</span>
                </div>
            </div>
        </div>
    );
}

export default ActivityChart;
